import { render, staticRenderFns } from "./DialogDashboards.vue?vue&type=template&id=b3a62c1a"
import script from "./DialogDashboards.vue?vue&type=script&lang=js"
export * from "./DialogDashboards.vue?vue&type=script&lang=js"
import style0 from "./DialogDashboards.vue?vue&type=style&index=0&id=b3a62c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports